import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class TypeColors extends ConfigNode
  @className = 'TypeColors'

  constructor: ->
    super('typeColors')

  map: ->
    @get('value')

  update: (map) ->
    @set('value', map, { dataType: 'json' })
    @save()

  reset: ->
    @update({})

  @load: ->
    super('typeColors', @)

export default TypeColors
